import styles from "./GroupCommentForm.module.css"
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import AlertService from "../../services/AlertService";
import {closeModal, openModal, setModalError} from "../../store/reducers/modalReducer";

const GroupCommentForm = () => {
    const dispatch = useDispatch();
    const selectedAlerts = useSelector(state => state.setAlertReducer.selectedAlerts)
    const [comment, setComment] = useState("")
    const onCommentSendClick = async () => {
        const commentRequest = {
            alert_id: selectedAlerts,
            comment: comment
        }
        try {
            await AlertService.postComment(commentRequest)
        }
        catch (e) {
            dispatch(openModal())
            dispatch(setModalError(e.response.data.name))
        } finally {
            setComment("")
            dispatch(closeModal())
        }
    }
    return(
            <div className={styles.commentWindow}>
                <h4 className={styles.commentWindowTitle}> Comment to selected alerts</h4>
                <form className={styles.commentForm}>
                            <textarea className={styles.commentTextArea}
                                      onChange={e => setComment(e.target.value)}
                            />
                    <button type="submit" className={`${styles.sendCommentButton} ${comment.trim().length < 5 ? styles.sendCommentButton_disabled : null}`}
                            disabled={comment.trim().length < 5}
                            onClick={e => {
                                e.preventDefault()
                                onCommentSendClick()
                            }}
                    >
                        Comment
                    </button>
                </form>
            </div>
    )
}

export default GroupCommentForm